import 'react-bootstrap-typeahead/css/Typeahead.css'
import { forwardRef, Ref, useCallback, useRef, useState } from 'react'
import { AsyncTypeahead } from 'react-bootstrap-typeahead'
import { useTranslation } from 'react-i18next'
import { getDocsSuggest } from '../../hooks/docs'
import styles from './SuggestionAutocomplete.module.css'
import Typeahead from 'react-bootstrap-typeahead/types/core/Typeahead'

const filterBy = () => true

interface Option {
  text: string
}

interface AutocompleteProps {
  documentTypes: string[]
  defaultInputValue: string
  onSubmitSearch(search: string): void
}

function SuggestionAutocomplete(
  { documentTypes, defaultInputValue, onSubmitSearch }: AutocompleteProps,
  ref: Ref<Typeahead>
) {
  const { i18n, t } = useTranslation()
  const abortRef = useRef<AbortController | null>(null)
  const [isLoading, setIsLoading] = useState(false)
  const [options, setOptions] = useState<Option[]>([])

  const handleSearch = useCallback(
    (search: string) => {
      setIsLoading(true)
      if (abortRef.current) {
        abortRef.current.abort()
      }
      abortRef.current = new AbortController()
      return getDocsSuggest(
        {
          search,
          lang: i18n.language,
          document_type: documentTypes,
        },
        abortRef.current.signal
      ).then((options) => {
        setOptions(options)
        setIsLoading(false)
      })
    },
    [documentTypes, i18n.language]
  )

  return (
    <AsyncTypeahead
      ref={ref}
      className={styles.SuggestionAucomplete}
      defaultInputValue={defaultInputValue}
      id="suggestion-search"
      delay={100}
      labelKey="text"
      placeholder={t('digita_il_termine_da_cercare')}
      onChange={(selected: any) => {
        if (selected.length > 0) {
          onSubmitSearch(selected[0].text)
        }
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          onSubmitSearch((e.target as any).value)
        }
      }}
      minLength={3}
      isLoading={isLoading}
      clearButton
      options={options}
      filterBy={filterBy}
      useCache
      onSearch={handleSearch}
    />
  )
}

export default forwardRef(SuggestionAutocomplete)
